/**
 * Cart order customization: dispatch date captured as a native cart-form
 * attribute ("Desired dispatch date"). NO AJAX cart writes are made here, so
 * Hulk's Cart Transform pricing is never disturbed.
 * Depends: flatpickr, subscribe/PUB_SUB_EVENTS (optional).
 */
(function () {
  function formatDisplay(date) {
    if (!date) return '';
    var d = String(date.getDate()).padStart(2, '0');
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var y = date.getFullYear();
    return d + '/' + m + '/' + y;
  }

  function parseDateString(s) {
    if (!s) return null;
    var t = String(s).trim();
    var iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(t);
    if (iso) {
      return new Date(parseInt(iso[1], 10), parseInt(iso[2], 10) - 1, parseInt(iso[3], 10));
    }
    var dmy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(t);
    if (dmy) {
      return new Date(parseInt(dmy[3], 10), parseInt(dmy[2], 10) - 1, parseInt(dmy[1], 10));
    }
    return null;
  }

  // NOTE: The dispatch date is stored as a CART ATTRIBUTE, never as line item
  // properties via /cart/change.js, because /cart/change re-triggers Shopify
  // Cart Transform, which can strip Hulk priced-option charges and corrupt the
  // cart total at checkout.

  function addFpFooter(calendarContainer, fp, strings) {
    var existing = calendarContainer.querySelector('.order-customization__fp-footer');
    if (existing) existing.remove();
    var footer = document.createElement('div');
    footer.className = 'order-customization__fp-footer';

    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'order-customization__fp-btn order-customization__fp-btn--clear';
    clearBtn.textContent = strings.clear;
    clearBtn.addEventListener('click', function () {
      fp.clear();
    });

    var todayBtn = document.createElement('button');
    todayBtn.type = 'button';
    todayBtn.className = 'order-customization__fp-btn order-customization__fp-btn--today';
    todayBtn.textContent = 'Earliest';
    todayBtn.addEventListener('click', function () {
      var t = getMinDispatchDays();
      fp.setDate(t, true);
    });

    footer.appendChild(clearBtn);
    footer.appendChild(todayBtn);
    calendarContainer.appendChild(footer);
  }

  function getStrings() {
    var d = window.cartLineCustomizationStrings || {};
    return { clear: d.clear || 'Clear', today: d.today || 'Today' };
  }

  // Earliest selectable dispatch date = N BUSINESS days after the order, counted
  // from the day AFTER the order and skipping weekends.
  // Example: order on Wed -> Thu(1) Fri(2) Mon(3) Tue(4) Wed(5) = the next Wed.
  // Set the number of business days via window.cartDispatchMinBusinessDays.
  function getMinDispatchDays() {
    var businessDays = window.cartDispatchMinBusinessDays || 5;
    var today = new Date();
    var added = 0;

    while (added < businessDays) {
      today.setDate(today.getDate() + 1);
      var dayOfWeek = today.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        added++; // only weekdays count
      }
    }

    // Compare by day, not by the current time of day.
    today.setHours(0, 0, 0, 0);
    
    return today;
  }

  var DISPATCH_STORAGE_KEY = 'eb_dispatch_date';

  function saveStoredDate(val) {
    try {
      if (val) {
        localStorage.setItem(DISPATCH_STORAGE_KEY, val);
      } else {
        localStorage.removeItem(DISPATCH_STORAGE_KEY);
      }
    } catch (e) {}
  }

  function getStoredDate() {
    try {
      return localStorage.getItem(DISPATCH_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  /*
   * Write the dispatch date into the hidden cart-form attribute input + the
   * confirmation UI. IMPORTANT: this makes NO AJAX cart write. The value rides
   * along with the native cart form submission at checkout (exactly like the
   * order note), so Hulk's Cart Transform is never re-run out of context and the
   * priced add-on charges stay intact. (An AJAX /cart/update.js or /cart/change
   * write here is what previously corrupted the checkout total.)
   */
  function setDispatchValue(root, val) {
    var hidden = root.querySelector('[data-dispatch-attr]');
    if (hidden) hidden.value = val || '';

    var confirmed = root.querySelector('[data-dispatch-confirmed]');
    var confirmedVal = root.querySelector('[data-dispatch-confirmed-value]');
    if (confirmed) {
      if (val) {
        if (confirmedVal) confirmedVal.textContent = val;
        confirmed.style.display = 'flex';
      } else {
        confirmed.style.display = 'none';
      }
    }
    saveStoredDate(val);
  }

  function getDispatchDate() {
    var hidden = document.querySelector('[data-dispatch-attr]');
    var val = hidden ? (hidden.value || '').trim() : '';
    return val || getStoredDate();
  }

  /*
   * Checkout routes that bypass the native cart form (multi-ship, Hulk draft-order
   * checkout) never submit the hidden attribute input, so the date would be lost.
   * They call this ONCE, right before leaving the cart, to persist it. This is the
   * only AJAX cart write for the dispatch date, and it happens at checkout time,
   * never while the customer is still editing the cart.
   */
  function persistDispatchDate(extraAttributes) {
    var attributes = Object.assign({}, extraAttributes || {});
    var val = getDispatchDate();
    if (val) attributes['Desired dispatch date'] = val;
    if (!Object.keys(attributes).length) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function (err) {
      console.error('Could not save dispatch date to cart', err);
    });
  }

  window.ebGetDispatchDate = getDispatchDate;
  window.ebPersistDispatchDate = persistDispatchDate;

  var currentFlatpickrInstance = null;

  function init(root) {
    var dateInput = root.querySelector('.cart-order-card__date-input');

    if (!dateInput || typeof flatpickr === 'undefined') return;
    if (dateInput._flatpickr) dateInput._flatpickr.destroy();

    var initDisp = getStoredDate() || (root.getAttribute('data-initial-dispatch') || '').trim();
    var initialDate = parseDateString(initDisp);

    currentFlatpickrInstance = flatpickr(dateInput, {
      dateFormat: 'd/m/Y',
      minDate: getMinDispatchDays(),
      allowInput: false,
      clickOpens: true,
      defaultDate: initialDate,
      locale: { firstDayOfWeek: 0 },
      disableMobile: true,
      monthSelectorType: 'dropdown',
      disable: [
        function(date) {
          // Disable weekends (0 = Sunday, 6 = Saturday)
          return (date.getDay() === 0 || date.getDay() === 6);
        }
      ],
      onChange: function (selectedDates) {
        // No AJAX cart write. Just sync the hidden cart-form attribute so the
        // value is submitted natively at checkout (Cart-Transform-safe).
        var val = selectedDates.length ? formatDisplay(selectedDates[0]) : '';
        setDispatchValue(root, val);
      },
      onReady: function (selectedDates, dateStr, instance) {
        addFpFooter(instance.calendarContainer, instance, getStrings());
      },
    });

    // Sync the hidden cart-form attribute on load (no AJAX cart write).
    setDispatchValue(root, initialDate ? formatDisplay(initialDate) : '');
  }

  function initAll() {
    if (typeof flatpickr === 'undefined') return;
    document.querySelectorAll('[data-order-customization]').forEach(init);
  }

  var retries = 0;
  function tryInitFirst() {
    if (typeof flatpickr !== 'undefined') {
      initAll();
      return;
    }
    if (++retries < 60) setTimeout(tryInitFirst, 50);
  }

  document.addEventListener('DOMContentLoaded', tryInitFirst);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Re-init the picker after cart re-renders. The stored date repopulates it
      // and re-syncs the hidden form attribute (still no AJAX cart write).
      setTimeout(function () {
        if (typeof flatpickr !== 'undefined') {
          initAll();
        }
      }, 450);
    });
  }
})();
